module.exports = __webpack_public_path__ + "img/tuceng20.df9d9d85.png";